import router from "./router";
import { getToken } from "./utils/auth";
import { Message } from "element-ui";
import { fetchAllPermissions } from "@/utils/permission";
const whiteList = ["/", "/login", "/register", "/forgot-password", "/change-password", "/wantBuy", "/finance", "/about"];
const greyList = ["procurement", "procurementDetail", "BuyDetail", "info", "finance", "about", "bannerDetail", "search"];

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  console.log(from);
  console.log(to);
  console.log(hasToken);
  if (hasToken) {
    console.log("有token");
    // console.log('需要校验认证相关');
    await fetchAllPermissions();
    if (to.path === "/login") {
      console.log("去首页");
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    console.log("没有token");
    if (whiteList.indexOf(to.path) !== -1) {
      console.log("111111");
      next();
    } else if (greyList.indexOf(to.path.split("/")[1]) !== -1) {
      next();
    } else {
      console.log("333333333333");
      Message({
        message: "请登录",
        type: "error",
        duration: 5 * 1000,
      });
      next(`/login?redirectUrl=${to.path}`);
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  window.scrollTo({ top: 0, behavior: "smooth" });
});
